import type { CheckboxChangeEvent } from 'antd';
import ContactsList from '@/components/contacts-list';
// import List from '@/components/list';
import { getAvatar } from '@/scripts/utils/genAvatar';
// import More from '@/assets/images/common/svg/more.svg?react';
import { useContactsContext } from '@/contexts/contacts/context';
import type { Contact } from '@/contexts/contacts/types';
import { useChatContext } from '@/contexts/chat/context';
import { useSessionContext } from '@/contexts/session/context';
import { GroupEncryptionStatus } from '@/configs/apis/groups/interface';
import type { GroupCreateProps } from './interface';
import styles from './index.module.scss';
import DeleteIcon from './images/delete.svg?react';
// import Category from './category';

export default function GroupCreate({ open, onCancel }: GroupCreateProps) {
  const [loading, setLoading] = useState(false);
  const { createChat, activeChat } = useChatContext();
  const {
    session: { user },
  } = useSessionContext();
  const { contacts } = useContactsContext();
  const [selectedContacts, setSelectedContacts] = useState<Contact[]>([]);
  const [groupName, setGroupName] = useState<string>('');
  const [isEncryption, setIsEncryption] = useState<GroupEncryptionStatus>(
    GroupEncryptionStatus.IS
  );

  const hasContacts = contacts.length > 0;

  // const onSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
  //   console.log(e.target.value);
  // }, []);

  const onContactSelect = useCallback((contacts: Contact[]) => {
    setSelectedContacts(contacts);
  }, []);

  const onContactDelete = useCallback(
    (contact: Contact) => {
      setSelectedContacts(selectedContacts.filter((c) => c.id !== contact.id));
    },
    [selectedContacts]
  );

  const onAllSelect = useCallback(
    (e: CheckboxChangeEvent) => {
      setSelectedContacts(e.target.checked ? contacts : []);
    },
    [contacts]
  );

  const createGroup = useCallback(async () => {
    try {
      if (loading) return;
      setLoading(true);
      const chat = await createChat({
        users: selectedContacts,
        group_name: groupName || `${user?.name} group`,
        is_encryption: isEncryption,
      });
      message.success('Group created successfully');
      setLoading(false);
      onCancel();
      if (chat) {
        activeChat(chat.chat_id);
      }
    } catch {
      setLoading(false);
    }
  }, [
    loading,
    createChat,
    selectedContacts,
    groupName,
    user?.name,
    isEncryption,
    onCancel,
    activeChat,
  ]);

  useLayoutEffect(() => {
    if (open) {
      setGroupName('');
      setSelectedContacts([]);
    }
  }, [open]);

  return (
    <Modal
      open={open}
      destroyOnHidden
      title="New group"
      onCancel={onCancel}
      centered
      width={730}
      maskClosable={false}
      styles={{
        content: {
          padding: '24px 16px',
        },
      }}
      footer={
        <Flex gap={16} justify="end">
          <Button onClick={onCancel}>Cancel</Button>
          <Button
            type="primary"
            loading={loading}
            onClick={createGroup}
            disabled={selectedContacts.length === 0}
          >
            Create
          </Button>
        </Flex>
      }
    >
      <div className={styles.groupCreate}>
        {/* <div className={styles.search}>
          <Input
            prefix={<SearchOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
            variant="filled"
            placeholder="Search"
            onChange={onSearch}
          />
        </div> */}
        {/* {selectedContacts.length > 0 && (
          <div className={styles.selectedContacts}>
            <div className={styles.selectedContactsList}>
              {selectedContacts.map((contact) => (
                <MyAvatar
                  key={contact.id}
                  src={getAvatar(contact.avatar, contact.name)}
                />
              ))}
            </div>
            <More />
          </div>
        )} */}
        {/* <div className={styles.groupList}>
          <List
            title="Group Type"
            gap={8}
            content={<span style={{ color: '#A3A3A3' }}>Chat</span>}
          />
        </div>
        <div className={styles.category}>
          <Category />
        </div> */}
        <div className={styles.contacts}>
          <Descriptions
            column={1}
            colon={false}
            styles={{
              label: {
                width: 135,
                color: '#1A1A1A',
              },
            }}
            items={[
              // {
              //   key: 'GroupType',
              //   label: 'Group Type',
              //   children: <Checkbox checked>Chat</Checkbox>,
              // },
              // {
              //   key: 'Group Avatar',
              //   label: 'Group Avatar',
              //   children: null,
              // },
              {
                key: 'GroupEncryption',
                label: 'Group Encryption',
                children: (
                  <Radio.Group
                    onChange={(e) => setIsEncryption(e.target.value)}
                    value={isEncryption}
                  >
                    <Radio value={GroupEncryptionStatus.IS}>Encryption</Radio>
                    <Radio value={GroupEncryptionStatus.NO}>No encryption</Radio>
                  </Radio.Group>
                ),
              },
              {
                key: 'GroupName',
                label: 'Group Name',
                children: (
                  <Input.TextArea
                    showCount
                    maxLength={60}
                    value={groupName}
                    rows={1}
                    onChange={(e) => setGroupName(e.target.value)}
                    placeholder="Enter Group Name (optional)"
                    style={{ resize: 'none' }}
                  />
                ),
              },
              // {
              //   key: 'GroupDescription',
              //   label: 'Group Description',
              //   children: (
              //     <Input.TextArea
              //       showCount
              //       maxLength={100}
              //       placeholder="Enter Group Description (optional)"
              //     />
              //   ),
              // },
              {
                key: 'GroupMembers',
                label: 'Group Members',
                children: (
                  <Card
                    className={styles.membersCard}
                    styles={{
                      body: {
                        padding: 0,
                        width: '100%',
                        display: 'flex',
                      },
                    }}
                  >
                    <div className={styles.membersCardContent}>
                      <div className={styles.orgList}>
                        {hasContacts && (
                          <Checkbox
                            indeterminate={
                              selectedContacts.length > 0 &&
                              selectedContacts.length < contacts.length
                            }
                            checked={selectedContacts.length === contacts.length}
                            onChange={onAllSelect}
                            style={{ paddingBottom: 10 }}
                          >
                            Select All
                          </Checkbox>
                        )}
                        <ContactsList
                          className={styles.contactsList}
                          contacts={contacts}
                          selectedContacts={selectedContacts}
                          onContactSelect={onContactSelect}
                          showAlphabetIndex={true}
                        />
                      </div>
                      <div className={styles.membersList}>
                        {hasContacts && (
                          <div className={styles.membersListTitle}>
                            Selected: {selectedContacts.length}{' '}
                            {selectedContacts.length > 1 ? 'Members' : 'Member'}
                          </div>
                        )}
                        <div
                          className={cls(
                            styles.membersListContentWrapper,
                            'scrollbar_hover'
                          )}
                        >
                          <div className={styles.membersListContent}>
                            {selectedContacts.map((contact) => (
                              <div className={styles.membersListItem} key={contact.id}>
                                <MyAvatar
                                  src={getAvatar(contact.avatar, contact.name)}
                                />
                                <div className={styles.membersContent}>
                                  <div className={styles.membersNames}>
                                    <div className={styles.name}>{contact.name}</div>
                                    {contact.username && (
                                      <div className={styles.uname}>
                                        @{contact.username}
                                      </div>
                                    )}
                                  </div>
                                  <DeleteIcon
                                    className="pointer"
                                    onClick={() => onContactDelete(contact)}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                ),
              },
            ]}
          />
        </div>
      </div>
    </Modal>
  );
}
